import { IconLock, IconLockOpen } from "@tabler/icons-react";
import styles from "./AiInsights.module.css";

export default function UnlockOverlay({ unlocked, price, onUnlock, disabled }) {
  return (
    <div
      className={`${styles.unlockOverlay} ${unlocked ? styles.unlockOverlayHidden : ""}`}
    >
      <div className={styles.unlockPanel}>
        <div className={styles.unlockIcon}>
          <IconLock size={20} />
        </div>
        <div className={styles.unlockTitle}>Unlock Full AI Insights</div>
        <div className={styles.unlockText}>
          See your personalized improvement plan and career blueprint.
        </div>
        <div className={styles.unlockPrice}>{price}</div>
        <button
          type="button"
          className={styles.unlockBtn}
          onClick={onUnlock}
          disabled={disabled}
        >
          <IconLockOpen size={15} /> {disabled ? "Loading..." : "Unlock Now"}
        </button>
      </div>
    </div>
  );
}
